export default "__VITE_ASSET__DfoAGrDk__"